import React from 'react';
import PropTypes from 'prop-types';
import mediator, { ACTIONS } from 'mediator';
import { ERROR_CONSTANTS } from 'constants';
import config from 'config';
import assign from 'lodash/assign';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import head from 'lodash/head';
import memoize from 'lodash/memoize';
import some from 'lodash/some';
import take from 'lodash/take';
import metrics from 'lib/common/metrics';
import features from 'lib/common/features';
import panToElement from 'lib/seatmaps/panToElement';
import processMiniCart from 'lib/cart/processMiniCart';
import excludeLockedItems from 'lib/cart/excludeLockedItems';
import repopulateSubLineItem from 'lib/cart/repopulateSubLineItem';
import filterByPriceTypes from 'lib/pricing/filterByPriceTypes';
import findSeatView from 'lib/seats/findSeatView';
import { findSeatEl } from 'lib/seats/seatFinders';
import { pricesForZone } from 'services/Pricer';
import API from 'services/API';

import Basket from 'components/Basket';
import SeatDetails from 'components/SeatDetails';
import EnhancedNotice from 'components/EnhancedNotice';
import AdaAttestation from 'components/AdaAttestation';
import logger from 'lib/common/logger';

function getCurrentPerformance(performances, id) {
  return find(performances, perf => parseInt(perf.perf_no, 10) === id);
}

const DetailsContainer = React.createClass({
  propTypes: {
    onComplete: PropTypes.func.isRequired,
    mode: PropTypes.string,
    prices: PropTypes.array,
    priceTypes: PropTypes.array,
    seatData: PropTypes.array,
    seatViews: PropTypes.array,
    maxTickets: PropTypes.number,
    currentCart: PropTypes.object,
    currentCartItems: PropTypes.array,
    currentFlexPackage: PropTypes.object,
    currentFixedPackage: PropTypes.object,
    isFixedPackagePerformance: PropTypes.bool,
    performances: PropTypes.array,
    currentPerformanceId: PropTypes.number,
    currentPackageNo: PropTypes.number,
    mainPanZoomInstance: PropTypes.object,
    activePromoCode: PropTypes.object,
    loginInfo: PropTypes.object,
    onChangePerformance: PropTypes.func.isRequired,
    leaveSingleSeats: PropTypes.string,
    mappedSeatsBySection: PropTypes.array,
    isExchange: PropTypes.bool,
    exchangeRules: PropTypes.object,
    isUpgrade: PropTypes.bool,
    upgradeRules: PropTypes.object,
    exchangeItemsAmount: PropTypes.number,
    exchangePriceTypes: PropTypes.array
  },
  getInitialState: function() {
    return {
      /**
             * The users selected seats
             *
             * TODO: rename to selectedSeats to avoid
             * confusion with Tessitura line items.
             */
      lineItems: [],

      /**
             * The currently selected seat
             *
             * TODO: rename to currentSelectedSeat
             */
      selectedSeat: null,

      /**
             * The users preferred price type
             * Set based on their initial selection
             */
      preferredPriceType: null,

      /**
             * Available upsell zones
             */
      upsells: [],

      /**
             * Any notices to be shown to the user
             * e.g. max tickets limit, processing error etc.
             */
      noticeMessage: null,

      /**
             * Is the cart currently processing?
             * Used to lock off UI whilst booking seats.
             */
      isProcessing: false,

      /**
             * Have the tickets been successfully
             * added to the cart?
             */
      isSuccessful: false,

      showAdaAttestation: false,

      adaAttestationSpecialRequests: null,

      currentPodSeats: null,
      currentPodAmount: null,
      podMinimum: 0,
      selectedPods: []
    };
  },
  componentWillMount: function() {
    mediator.subscribe(ACTIONS.SEAT_SELECTED, this.handleSeatSelection);
  },
  componentWillUnmount: function() {
    mediator.unsubscribe(ACTIONS.SEAT_SELECTED, this.handleSeatSelection);
  },
  componentDidMount: function() {
    let currentCartItems = this.props.currentCartItems;

    let lockedPriceTypes;
    if (this.props.isFixedPackagePerformance) {
      lockedPriceTypes = features.getOption('lockedSeats', 'lockedPriceTypes');
    }

    /**
         * Show existing cart items in the mini-cart and on the map.
         */
    if (currentCartItems.length) {
      /**
             * Map cart items into a full object
             * w/ seat data and seat element etc.
             */
      let existingItems = currentCartItems.map(item => {
        return repopulateSubLineItem(
          item,
          this.props.seatData,
          this.props.prices,
          this.props.performances,
          lockedPriceTypes
        );
      });

      if (features.isEnabled('podSeats')) {
        this.repopulateExistingPods(currentCartItems);
        existingItems = existingItems.filter(lineItem => {
          return lineItem.seatData.seat_num < 2;
        });
      }
      /**
             * Mark cart seats as selected in seat-map
             */
      existingItems.forEach(item => {
        if (item && item.customSeatEl) {
          mediator.publish(ACTIONS.SEAT_TOGGLE_SELECTED, {
            seatEl: item.customSeatEl
          });
        } else if (item && item.seatEl) {
          mediator.publish(ACTIONS.SEAT_TOGGLE_SELECTED, {
            seatEl: item.seatEl
          });
        }
      });

      /**
             * Pan and zoom to first seat element from cart
             */
      panToElement(head(existingItems).seatEl, this.props.mainPanZoomInstance);

      /**
             * Merge existing cart-items with newly selected items
             */
      this.setState(prevState => {
        return {
          lineItems: existingItems
            .concat(prevState.lineItems)
            .filter(x => x !== undefined)
        };
      });
    }

    /**
         * Fetch upsells
         */
    if (features.isEnabled('inlineSeatUpsell')) {
      API.SeatUpsells().then(remoteData => {
        if (remoteData) {
          this.setState({
            upsells: remoteData
          });
        }
      });
    }
  },
  repopulateExistingPods: function(currentLineItems) {
    let existingPods = [];
    let obj = {};
    currentLineItems.forEach(item => {
      let seatNo = parseInt(item.seat_no);
      let section = Object.keys(this.props.mappedSeatsBySection).find(key =>
        this.props.mappedSeatsBySection[key].includes(seatNo)
      );

      if (!(section in obj)) {
        obj[section] = {
          seats: []
        };
      }

      let seats = [...obj[section].seats, seatNo];
      obj[section] = {
        price_type: item.price_type,
        seats: seats
      };
    });

    for (const [key, value] of Object.entries(obj)) {
      existingPods.push({
        section: key,
        priceType: value.price_type,
        amount: value.seats.length,
        seats: value.seats
      });
    }

    this.setState({
      selectedPods: existingPods
    });
  },
  getSeatViewForSelection: function(selection) {
    /* eslint-disable no-empty */
    let seatView;
    try {
      seatView = findSeatView(
        this.props.seatData,
        this.props.seatViews,
        selection
      );
    } catch (e) {}
    return seatView;
  },
  isExchangeValid() {
    let isExchangeValid = true;

    if (
      this.props.isExchange &&
      !this.props.isUpgrade &&
      this.state.lineItems.filter(x => {
        return (
          this.props.exchangeRules.current.length === 0 ||
          this.props.exchangeRules.current.indexOf(
            parseInt(x.priceData.price_type)
          ) > -1
        );
      }).length !== this.props.exchangeItemsAmount
    ) {
      isExchangeValid = false;
    } else if (
      this.props.isExchange &&
      this.props.isUpgrade &&
      this.state.lineItems.filter(x => {
        return (
          this.props.upgradeRules.current.length === 0 ||
          this.props.upgradeRules.current.indexOf(
            parseInt(x.priceData.price_type)
          ) > -1
        );
      }).length !== this.props.exchangeItemsAmount
    ) {
      isExchangeValid = false;
    }

    return isExchangeValid;
  },
  isBookButtonDisabled: function() {
    let isExchangeValid = this.isExchangeValid();

    return this.props.isProcessing || !isExchangeValid;
  },
  getPriceTypesForSelection: function(seat) {
    const {
      mode,
      prices,
      priceTypes,
      currentCart,
      currentCartItems,
      loginInfo
    } = this.props;

    const currentMOS = parseInt(loginInfo.MOS, 10);
    let filteredPriceTypes = filterByPriceTypes(
      mode,
      currentMOS,
      prices,
      priceTypes,
      currentCart,
      currentCartItems,
      this.state.lineItems
    );

    if (
      this.props.isExchange &&
      !this.props.isUpgrade &&
      this.props.exchangeRules.current &&
      this.props.exchangeRules.current.length > 0
    ) {
      if (this.isExchangeValid()) {
        filteredPriceTypes = filteredPriceTypes.filter(
          x =>
            this.props.exchangeRules.extra.indexOf(parseInt(x.price_type)) > -1
        );
      } else {
        filteredPriceTypes = filteredPriceTypes.filter(
          x =>
            this.props.exchangeRules.current.indexOf(parseInt(x.price_type)) >
            -1
        );
      }
    } else if (
      this.props.isExchange &&
      this.props.isUpgrade &&
      this.props.upgradeRules.current &&
      this.props.upgradeRules.current.length > 0
    ) {
      if (this.isExchangeValid()) {
        filteredPriceTypes = filteredPriceTypes.filter(
          x =>
            this.props.upgradeRules.extra.indexOf(parseInt(x.price_type)) > -1
        );
      } else {
        filteredPriceTypes = filteredPriceTypes.filter(
          x =>
            this.props.upgradeRules.current.indexOf(parseInt(x.price_type)) > -1
        );
      }
    }

    return pricesForZone(filteredPriceTypes, seat.seatData.zone_no);
  },
  findUpsell: function() {
    if (!features.isEnabled('inlineSeatUpsell')) {
      return;
    }

    const { upsells, selectedSeat } = this.state;

    /**
         * Find the first upsell for the current price-zone
         */
    const upsellDetails = find(upsells, function(upsell) {
      const selectionZone = parseInt(selectedSeat.seatData.zone_no, 10);
      const upsellZone = parseInt(upsell.original_zone_no, 10);
      return selectionZone === upsellZone;
    });

    const upsellMatch =
      upsellDetails &&
      find(this.props.seatData, function(seat) {
        return (
          seat.zone_no == upsellDetails.upgrade_zone_no &&
          seat.seat_status.id == '0'
        );
      });

    /**
         * Get a matching seat from the upsold price zone
         */
    if (upsellMatch) {
      const upsoldSeat = {
        seatEl: findSeatEl(upsellMatch),
        seatData: upsellMatch
      };

      return {
        seat: upsoldSeat,
        seatView: this.getSeatViewForSelection(upsoldSeat),
        prices: take(
          pricesForZone(this.props.prices, upsoldSeat.seatData.zone_no),
          1
        ),
        referencePriceType: head(this.getPriceTypesForSelection(selectedSeat)),
        performanceId: this.props.currentPerformanceId
      };
    } else {
      return;
    }
  },
  onSelectUpsell: function(upsoldSeat, priceType) {
    const panZoomInstance = this.props.mainPanZoomInstance;

    // Deselect original seat
    this.handleDeselection(this.state.selectedSeat, true);

    // Pan to new seat element
    panToElement(upsoldSeat.seatEl, panZoomInstance, panZoomInstance.getZoom());

    // Select up-sold seat
    mediator.publish(ACTIONS.SEAT_ADDED, upsoldSeat);
    this.handlePriceTypeSelection(upsoldSeat, priceType);
  },
  handleSeatSelection: function(selection) {
    const { lineItems, isProcessing } = this.state;

    if (isProcessing) {
      return;
    }

    /* Is the selection already selected i.e. trying to de-select a seat */
    const isSeatAlreadySelected = some(lineItems, function(item) {
      return item.seatData.seat_no === selection.seatData.seat_no;
    });

    if (features.isEnabled('podSeats')) {
      var podSeats = this.props.mappedSeatsBySection[
        selection.seatData.section
      ];

      let overridePodAmount = features.getOption('podSeats', 'minimumPerZones');
      let defaultPodAmount = features.getOption('podSeats', 'minimum');

      if (overridePodAmount.length) {
        let zone = selection.seatData.zone_no;

        let limitDetails = find(overridePodAmount, item => {
          return item.zone_ids.includes(zone);
        });

        if (limitDetails) {
          this.setState({
            currentPodAmount: podSeats.length,
            podMinimum:
              limitDetails.min_seats > podSeats.length
                ? podSeats.length
                : limitDetails.min_seats
          });
        } else {
          this.setState({
            podMinimum:
              podSeats.length < defaultPodAmount
                ? podSeats.length
                : defaultPodAmount,
            currentPodAmount: podSeats.length
          });
        }
      } else {
        this.setState({
          podMinimum:
            podSeats.length < defaultPodAmount
              ? podSeats.length
              : defaultPodAmount,
          currentPodAmount: podSeats.length
        });
      }
    }

    /* Have we reached the maximum ticket limit? */
    if (
      lineItems.length === this.props.maxTickets &&
      isSeatAlreadySelected === false
    ) {
      this.setState({
        noticeMessage: config.maxTicketsMessage
      });
    } else {
      /**
        * Mark the seat as selected on the seat-map.
        */
      mediator.publish(ACTIONS.SEAT_ADDED, selection);

      /* Has the zone already been selected? */
      const isZoneAndSameTypeAlreadySelected = some(lineItems, function(item) {
        let lineItemType = item.seatData.hc_no
          ? item.seatData.hc_no
          : item.seatData.seat_type;
        let selectionType = selection.seatData.hc_no
          ? selection.seatData.hc_no
          : selection.seatData.seat_type;

        return (
          item.seatData.zone_no === selection.seatData.zone_no &&
          lineItemType === selectionType
        );
      });

      /**
             * IF
             * a) We have a preffered price type (already selected a seat)
             * b) We have some items in our mini-cart
             * c) We haven't selected this zone before
             * d) We've not already selected the seat (were trying to de-select a seat?)
             * THEN
             * Automatically select preffered price type.
             * ELSE
             * Show the seat details popup.
             */
      let shouldShowSeatDetails = true;
      if (
        features.isEnabled('preferredPriceType') &&
        this.state.preferredPriceType &&
        lineItems.length > 0 &&
        isZoneAndSameTypeAlreadySelected &&
        !isSeatAlreadySelected
      ) {
        const selectedPriceType = find(
          this.getPriceTypesForSelection(selection),
          item => {
            return item.price_type === this.state.preferredPriceType;
          }
        );

        if (selectedPriceType) {
          shouldShowSeatDetails = false;
          this.handlePriceTypeSelection(selection, selectedPriceType);
        }
      }

      let states = {
        noticeMessage: null
      };

      if (features.isEnabled('podSeats')) {
        states.currentPodSeats = podSeats;
      }

      if (shouldShowSeatDetails) {
        states.selectedSeat = selection;
      }

      this.setState(states);
    }
  },
  handlePodsSelection: function(event) {
    let val = event.target.value;

    this.setState({
      currentPodAmount: val
    });
  },
  handlePriceTypeSelection: function(seat, priceData) {
    const seatSelection = {
      seatEl: seat.seatEl,
      seatData: seat.seatData,
      priceData: priceData,

      //@TODO: Is this still needed?
      performance: getCurrentPerformance(
        this.props.performances,
        this.props.currentPerformanceId
      )
    };

    this.setState(prevState => {
      let newState = {
        // Add to the front without mutating original list
        lineItems: [seatSelection].concat(prevState.lineItems)
      };

      if (!prevState.preferredPriceType) {
        newState.preferredPriceType = seatSelection.priceData.price_type;
      }

      if (features.isEnabled('podSeats')) {
        const podSeats = this.props.mappedSeatsBySection[
          seatSelection.seatData.section
        ];

        const podSeatsAmount =
          this.state.currentPodAmount > podSeats.length
            ? podSeats.length
            : this.state.currentPodAmount;

        newState.selectedPods = [
          ...this.state.selectedPods,
          {
            section: seatSelection.seatData.section,
            amount: podSeatsAmount,
            priceType: seatSelection.priceData.price_type,
            seats: podSeats
          }
        ];
      }

      return newState;
    });

    this.handleDeselection(seat, false);
  },
  handleDeselection: function(seat, deselect) {
    this.setState({ selectedSeat: null });
    if (deselect) {
      mediator.publish(ACTIONS.SEAT_DESELECTED, seat);
    }
  },
  handleReselection: function(lineItem) {
    mediator.publish(ACTIONS.SEAT_SELECTED, lineItem);
  },
  handleRemoval: function(lineItem) {
    let { lineItems, isProcessing } = this.state;

    if (!isProcessing) {
      mediator.publish(ACTIONS.SEAT_DESELECTED, lineItem);
      let idx = findIndex(lineItems, lineItem);

      // Remove item without mutating original list
      let newItems = lineItems.slice(0, idx).concat(lineItems.slice(idx + 1));

      if (features.isEnabled('podSeats')) {
        let podIndex = findIndex(this.state.selectedPods, item => {
          return item.section == lineItem.seatData.section;
        });

        let newPods = this.state.selectedPods
          .slice(0, podIndex)
          .concat(this.state.selectedPods.slice(podIndex + 1));

        this.setState({
          selectedPods: newPods
        });
      }

      this.setState({
        lineItems: newItems,
        noticeMessage: null
      });
    }
  },
  handlePriceTypeChange: function(lineItem, priceData) {
    const { lineItems, isProcessing } = this.state;

    const currentPerformance = getCurrentPerformance(
      this.props.performances,
      this.props.currentPerformanceId
    );

    if (!isProcessing) {
      const replacementLineItemData = {
        seatEl: lineItem.seatEl,
        seatData: lineItem.seatData,
        priceData: priceData,
        performance: currentPerformance
      };

      // Get the index of the existing item
      const idx = findIndex(lineItems, lineItem);

      // Add in the new line item, we are going to mutate the list here.
      const newItems = lineItems.slice(0, idx).concat(lineItems.slice(idx + 1));

      // Insert the new item at the same position as the old item.
      newItems.splice(idx, 0, replacementLineItemData);

      this.setState({
        lineItems: newItems,
        noticeMessage: null
      });
    }
  },
  getAdaSeatSelections: function(processableSeatSelections) {
    return processableSeatSelections.filter(x =>
      includes(
        features.getOption('adaAttestation', 'holdCodeIds'),
        x.seatData.hasOwnProperty('hc_no') ? x.seatData.hc_no : 0
      )
    );
  },
  hasAlreadyAcceptedAdaAttestation: function() {
    const { currentPerformanceId } = this.props;
    let alreadyAccepted = false;

    try {
      const adaMeta = localStorage.getItem(
        `PerformanceADAMeta-${currentPerformanceId}`
      );
      if (currentPerformanceId && adaMeta) {
        alreadyAccepted = true;
      }
    } catch (e) {} // eslint-disable-line no-empty

    return alreadyAccepted;
  },
  optionallyStoreAdaCsiData: function() {
    const { currentPerformanceId } = this.props;
    const { adaAttestationSpecialRequests } = this.state;
    const csiConfigData = features.getOption('adaAttestation', 'csiData');

    const shouldStore =
      csiConfigData &&
      currentPerformanceId &&
      !isEmpty(adaAttestationSpecialRequests);

    if (shouldStore) {
      let csiData = assign(
        {},
        csiConfigData[Object.keys(adaAttestationSpecialRequests.options)[0]],
        {
          Notes: JSON.stringify(adaAttestationSpecialRequests),
          PerformanceNumber: currentPerformanceId
        }
      );

      return API.StoreADACSIData({
        performance: currentPerformanceId,
        csiData
      }).catch(function() {
        logger.captureMessage(
          `Failed to store PerformanceADAMeta for ${currentPerformanceId}`
        );
      });
    }
  },
  handleSubmit: function() {
    this.setState({
      isProcessing: true
    });

    /**
         * Exclude locked items from processing
         */
    var processableLineItems = this.state.lineItems.filter(
      item => !item.isLocked
    );

    if (features.isEnabled('podSeats') && this.state.selectedPods.length) {
      processableLineItems['podSeats'] = this.state.selectedPods;
    }

    var currentCartItems = excludeLockedItems(
      this.state.lineItems,
      this.props.currentCartItems
    );

    var requiresAdaAttestation =
      features.isEnabled('adaAttestation') &&
      this.getAdaSeatSelections(processableLineItems).length > 0 &&
      !this.hasAlreadyAcceptedAdaAttestation() &&
      !this.state.adaAttestationSpecialRequests;

    if (requiresAdaAttestation) {
      this.setState({
        showAdaAttestation: true
      });
    } else {
      processMiniCart(
        this.props.currentCart,
        currentCartItems,
        processableLineItems,
        this.props.currentPerformanceId,
        this.props.currentPackageNo,
        this.props.currentFixedPackage,
        this.props.currentFlexPackage,
        this.props.leaveSingleSeats
      )
        .then(response => {
          this.setState({
            isSuccessful: true
          });

          this.optionallyStoreAdaCsiData();

          let redirectPath = this.props.onComplete.call(null, response);
          if (this.props.currentPerformanceId) {
            redirectPath = redirectPath.replace(
              'instance_id',
              this.props.currentPerformanceId
            );
          } else {
            redirectPath = redirectPath.replace(
              'instance_id',
              this.props.currentPackageNo ||
                this.props.currentFixedPackage ||
                this.props.currentFlexPackage
            );
          }

          window.location.href = redirectPath;
        })
        .catch(error => {
          this.setState({
            isProcessing: false
          });

          if (error && error.message) {
            this.setState({
              noticeMessage: error.message
            });
          }
        });
    }
  },

  handleAcceptAdaAttestation: function(adaChoices, specialRequestsExtra) {
    var adaAttestationSpecialRequests = {};

    if (adaChoices) {
      adaAttestationSpecialRequests.options = adaChoices;
    }

    if (specialRequestsExtra) {
      adaAttestationSpecialRequests.other = specialRequestsExtra;
    }
    let seatData = '';
    let seats = this.state.lineItems;
    seats.map(function(seat, key) {
      seatData = seatData.concat(
        `${seat.seatData.section_desc} ${seat.seatData.seat_row} ${seat.seatData
          .seat_num}, `
      );
    });
    adaAttestationSpecialRequests.seats = seatData;

    this.setState(
      {
        showAdaAttestation: false,
        adaAttestationSpecialRequests: adaAttestationSpecialRequests
      },
      () => {
        this.handleSubmit();
      }
    );
  },
  handleDeclineAdaAttestation: function() {
    this.setState({
      isProcessing: false,
      showAdaAttestation: false
    });
  },

  /**
     * Handle refreshing the seat map.
     * Used if there was a pottential seat collision.
     * Gives the user the option to refresh the feed and try again.
     */
  handleRefreshSeatmap: function() {
    if (!this.props.currentPerformanceId) {
      return;
    }

    this.setState(
      {
        lineItems: []
      },
      () => {
        metrics.action(
          'Refresh seat availability',
          `Refresh seat availability for performance ${this.props
            .currentPerformanceId}`
        );

        this.props.onChangePerformance(
          this.props.currentPerformanceId,
          true // refreshSeatData
        );
      }
    );
  },

  renderEnhancedNotice: function() {
    const notices = [
      {
        errorName: ERROR_CONSTANTS.LEAVES_SINGLE_SEAT,
        title: 'One or more of your seats could not be reserved',
        content: () => {
          return (
            <p>
              One or more of your seats would leave a single seat in a row.
              Please select different seats and try again.
            </p>
          );
        },
        actionLabel: 'OK',
        actionFn: () => {
          this.setState({
            noticeMessage: null
          });
        }
      },
      {
        errorName: ERROR_CONSTANTS.SEATS_UNAVAILABLE,
        title: 'One or more of your seats could not be reserved',
        content: () => {
          return (
            <p>
              This may be because someone has already reserved one of your
              selected seats. Try{' '}
              <strong>refreshing the seat availability</strong> or{' '}
              <strong>selecting other seats</strong>.
            </p>
          );
        },
        actionLabel: 'Refresh seat availability',
        actionFn: () => {
          this.handleRefreshSeatmap();
        }
      }
    ];

    const matchingNotice = find(
      notices,
      notice => notice.errorName === this.state.noticeMessage
    );
    if (matchingNotice) {
      return (
        <EnhancedNotice
          notice={matchingNotice}
          onClose={() => {
            this.setState({
              noticeMessage: null
            });
          }}
        />
      );
    } else {
      return null;
    }
  },

  renderSeatDetails: function(selection) {
    /**
         * Check if we have selected a current cart item
         * so we can change the UI as needed.
         */
    let currentLineItem = selection
      ? find(this.state.lineItems, function(item) {
          return selection.seatData.seat_no === item.seatData.seat_no;
        })
      : null;

    const canShowSeatDetails = selection && !get(currentLineItem, 'isLocked');

    return canShowSeatDetails ? (
      <SeatDetails
        selectedSeat={selection}
        seatView={this.getSeatViewForSelection(selection)}
        priceTypes={this.getPriceTypesForSelection(selection)}
        currentLineItem={currentLineItem}
        handleSelection={this.handlePriceTypeSelection}
        handleDeselection={this.handleDeselection}
        handleRemoval={this.handleRemoval}
        upsell={this.findUpsell()}
        onSelectUpsell={this.onSelectUpsell}
        currentPodSeats={this.state.currentPodSeats}
        currentPodAmount={this.state.currentPodAmount}
        handlePodSelection={this.handlePodsSelection}
        selectedPods={this.state.selectedPods}
        podMinimum={this.state.podMinimum}
      />
    ) : null;
  },
  renderBasket: function(lineItems) {
    var basketButtonLabel = memoize(() => {
      if (this.state.isSuccessful) {
        return config.basket.successLabel;
      } else if (this.state.isProcessing) {
        return config.basket.processingLabel;
      } else if (this.props.currentCartItems.length) {
        return config.basket.updateLabel;
      } else {
        return config.basket.submitLabel;
      }
    });

    var noticeMessage = this.state.noticeMessage;
    var promoCodeMessage = get(this.props.activePromoCode, 'text2');
    if (!noticeMessage && promoCodeMessage) {
      noticeMessage = promoCodeMessage;
    }

    return lineItems.length ? (
      <Basket
        lineItems={lineItems}
        prices={this.props.prices}
        buttonLabel={basketButtonLabel()}
        noticeMessage={noticeMessage}
        handleSubmit={this.handleSubmit}
        handleRemoval={this.handleRemoval}
        handleReselection={this.handleReselection}
        handlePriceTypeChange={this.handlePriceTypeChange}
        handleRefreshSeatmap={this.handleRefreshSeatmap}
        isProcessing={this.state.isProcessing}
        selectedPods={this.state.selectedPods}
        isExchange={this.props.isExchange}
        isBookButtonDisabled={this.isBookButtonDisabled()}
        isUpgrade={this.props.isUpgrade}
        exchangeItemsAmount={this.props.exchangeItemsAmount}
        exchangePriceTypes={this.props.exchangePriceTypes}
      />
    ) : null;
  },
  renderAdaAttestation: function() {
    let canShowAdaAttestation =
      this.state.showAdaAttestation && features.isEnabled('adaAttestation');

    return canShowAdaAttestation ? (
      <AdaAttestation
        handleSelection={this.handleAcceptAdaAttestation}
        handleDeselection={this.handleDeclineAdaAttestation}
        specialRequestOptions={features.getOption(
          'adaAttestation',
          'specialRequestOptions'
        )}
      />
    ) : null;
  },
  render: function() {
    return (
      <div className="syos-details-container">
        {this.renderEnhancedNotice()}
        {this.renderSeatDetails(this.state.selectedSeat)}
        {this.renderBasket(this.state.lineItems)}
        {this.renderAdaAttestation()}
      </div>
    );
  }
});

export default DetailsContainer;



// WEBPACK FOOTER //
// ./src/javascripts/app/containers/DetailsContainer.js